import Image from 'next/image'
import { extractPublicId, buildImageUrl } from 'cloudinary-build-url'
import React from 'react'
import { BadgeHeader } from '../BadgeHeader'
import { BaseCard } from '../BaseCard'
import { CardFooter } from '../CardFooter'
import { DiscountHeader } from '../DiscountHeader'
import { RaceCardProps } from '../index'
import { Overlay } from '../Overlay'
import { ProgressSection } from '../ProgressSection'

// import { toBase64, shimmer } from 'src/common/utils'

const getCloudinaryURL = (url, width, quality): string => {
    const pubID = extractPublicId(url)
    const cloudinaryUrl: string = buildImageUrl(pubID, {
        cloud: {
            cloudName: 'yes-fit'
        },
        transformations: {
            rawTransformation: 't_card-image',
            width: width,
            quality: quality,
            format: 'jpg'
        }
    })

    return cloudinaryUrl
}

export const RaceCard = ({
    title,
    subtitle,
    imageURL,
    badgeType = 'none',
    progress,
    distance = '',
    percentOff = 0,
    premiumText,
    href = '/'
}: RaceCardProps) => {
    return (
        <BaseCard href={href} cardType="narrow" boxShadow={false}>
            <Image
                alt={`${title} card image`}
                src={imageURL}
                width={225}
                height={300}
                objectFit="cover"
                className="bg-gray-400"
                loader={({ src, width, quality }) => {
                    return src.startsWith('https://res.cloudinary.com')
                        ? getCloudinaryURL(src, width, quality)
                        : src
                }}
                // placeholder="blur"
                // blurDataURL={`data:image/svg+xml;base64,${toBase64(shimmer(225, 300))}`}
            />
            {/* <img
                loading="lazy"
                alt={`${title} card image`}
                src={imageURL}
                className="object-cover w-[225px] h-[300px]"
            /> */}
            <BadgeHeader badgeType={badgeType} premiumText={premiumText} />
            <DiscountHeader percent={percentOff} />
            <CardFooter
                type="race"
                title={title}
                subtitle={subtitle}
                distance={distance}
                progress={progress}
            />

            <ProgressSection progress={progress} color="primary" />

            <Overlay />
        </BaseCard>
    )
}
